<template>
  <div class="cp-mobility-offers">
    <div class="teq-container">
      <h2>envie de prendre l'air ?</h2>
      <div class="item">
        <div
          class="illust-container"
        >
          <img
            class="illust"
            src="../../../images/reservation-zoe.webp"
            alt=""
          >
        </div>
        <h3>réservez Renault Zoe <br>100% électrique</h3>
        <div class="list-container">
          <p>
            Que ça soit pour un weekend à la montagne ou pour des vacances à la mer, gardez les pieds sur terre et oubliez l’avion. <br>Voyagez sans aucune contrainte et en toute sérénité avec Zoe airlines. <br>Evadez-vous du quotidien et goutez aux plaisirs de la conduite électrique, en louant une Renault Zoe 100% électrique.
          </p>
        </div>
        <div class="list-container">
          <ul>
            <li>Appareil écoresponsable, performant et agréable à conduire.</li>
            <li>Voyagez systématiquement côté hublot.</li>
            <li>Aucun frais supplémentaire pour les bagages.</li>
            <li>Parcourez jusqu'à 395 km en toute autonomie, sans avoir à vous brancher.</li>
          </ul>
          <h4> nous vous souhaitons d’agréables voyages à bord de Renault ZOE</h4>
        </div>
      </div>
      <div class="item">
        <div
          class="illust-container"
        >
          <img
            class="illust"
            src="../../../images/location-zoe.webp"
            alt=""
          >
        </div>
        <h3>location week-end pour 59€</h3>
        <div class="list-container">
          <p>
            Pour 59€*, réservez Renault Zoe 100% électrique tout un week-end, du vendredi soir au lundi matin, et partez à l’aventure sans aucune limite kilométrique. <br>Bouclez vos ceintures et laissez-vous guider par vos envies.
          </p>
        </div>
        <div class="list-container">
          <ul>
            <li>Paris > Rennes <br>350km</li>
            <li>Lyon > Marseille <br> 314km</li>
            <li>Biarritz > Bilbao <br> 148km</li>
          </ul>
          <h4>il ne vous reste plus qu'à choisir la destination</h4>
        </div>
      </div>
    </div>

    <div class="button-container">
      <rent-button
        @buttonclicked="scrollToTop()"
        is-anchor
      >
        réservez maintenant
      </rent-button>
    </div>
    <div class="teq-container conditions">
      <p>*Prix TTC, kilométrage illimité, franchise dommage de 950€TTC. Offre valable du 01/07 au 28/02/2022 dans le réseau Mobilize Share participant, sous réserve de disponibilité, pour toute location d’une Renault Zoe E-Tech Electrique sur un week end, réception du véhicule entre le vendredi 17h00 et la fermeture de l’agence –restitution du véhicule le lundi, de l’ouverture de l’agence jusqu’à 9h00.</p>
    </div>
  </div>
</template>

<script>
import RentButton from '../shared/RentButton'

export default {
  components: { RentButton },
  name: 'MobilityOffers',

  props: {
    isMobility: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
}
</script>

<style lang="scss" scoped>

.cp-mobility-offers {
  padding-top: 5rem;
  position: relative;
  //z-index: -1;

  @include teq-breakpoint($large) {
    margin-bottom: 5.5rem;
    padding-top: 17rem;
  }
}

.teq-container {
  @include teq-breakpoint($large) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

h2 {
  font-size: 4.8rem;
  line-height: 100%;

  @include teq-breakpoint($large) {
    font-size: 7.2rem;
  }
}

h3 {
  margin: 2rem 0 2.8rem;

  @include teq-breakpoint($large) {
    margin: 3.3rem 0 2.5rem;
  }
}

h4 {
  color: #1f2532;
  font-size: 1.8rem;
  font-weight: bold;
  line-height: 3.24rem;
  margin: 1rem 0;
  //text-transform: uppercase;
}

.item {
  margin-bottom: 4rem;
  width: 100%;

  @include teq-breakpoint($large) {
    margin-bottom: 0;
    width: calc(50% - 1rem);
  }
}

.illust-container {
  margin-bottom: 2.6rem;
  overflow: hidden;
  position: relative;

  @include teq-breakpoint($large) {
    margin-bottom: 2rem;
  }

  &::before {
    content: "";
    display: block;
    padding-top: calc(9 / 16);
    width: 100%;

    @include teq-breakpoint($large) {
      padding-top: calc(163 / 290);
    }
  }
}

.illust {
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
}

.list-container {
  margin-bottom: 1rem;

  @include teq-breakpoint($large) {
    margin-bottom: 2rem;
    padding-right: 8rem;
  }

  p {
    color: #1f2532;
    font-family: $f-graphie-book;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: normal;
    line-height: 2.2rem;
    margin-bottom: 1.2rem;
    position: relative;
  }
}

ul {
  margin-bottom: 2.6rem;

  @include teq-breakpoint($large) {
    list-style: none;
    margin-bottom: 2.4rem;
  }
}

li {
  color: #1f2532;
  font-family: $f-graphie-book;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: normal;
  line-height: 2.2rem;
  margin-bottom: 1.2rem;
  padding-left: 3.2rem;
  position: relative;

  &::before {
    border-bottom: 2px solid $orange;
    content: '';
    margin-left: -30px;
    position: absolute;
    top: 10px;
    width: 10px;
  }
}

.button-container {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 5rem;
  max-width: calc(100% - 5.6rem);
  width: calc(100% - 5.6rem);
}

.conditions {
  margin-bottom: 2rem;
  margin-top: 2rem;

  @include teq-breakpoint($large) {
    margin-bottom: initial;
    margin-top: 5rem;
  }

  p {
    color: #1f2532;
    font-family: $f-graphie-book;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: normal;
    line-height: 2.2rem;
  }
}
</style>
